import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Button } from 'components/button/Button'
import { Caption, Text } from 'components/Typography'
import { BREAKPOINTS, pxToRem } from 'utils/styled'

export const SActionWrapper = styled.div<{ hasActionLabel: boolean }>`
  align-self: flex-end;
  margin-left: 1.5rem;
  display: flex;

  ${({ hasActionLabel }) => hasActionLabel && `margin-top: 1.5rem;`}

  & svg {
    transition: transform 0.3s ease;
  }
`

export const SWrapper = styled(Button)<{ hasActionLabel: boolean }>`
  height: 100%;
  width: 100%;
  padding: 1.5rem;

  & :hover {
    & > ${SActionWrapper} svg {
      transform: translateX(0.5rem);
    }
  }

  & > span {
    width: 100%;
    height: 100%;
    display: flex;

    align-items: flex-start;
    justify-content: space-between;
    text-align: start;
    font-weight: normal;

    ${({ hasActionLabel }) => hasActionLabel && `flex-direction: column;`}
  }

  @media ${BREAKPOINTS.MD.max} {
    padding: 1rem;

    & > span {
      flex-direction: column;
    }
  }
`

export const STitleRow = styled.div<{ hasIcon: boolean }>`
  display: flex;

  ${({ hasIcon }) => hasIcon && `margin-bottom: 0.5rem;`}

  & > svg {
    margin: 0 0.5rem 0.5rem 0;
    color: var(--c-black);
  }
`

export const STextWrapper = styled.div<{ noDescription: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${({ noDescription }) =>
    noDescription &&
    css`
      height: 100%;

      ${STitleRow} {
        flex-direction: column;
        margin: 0;
        flex: 1;
        justify-content: space-between;
      }

      ${STitle} {
        font-size: 1.25rem;
        line-height: 1.825rem;
        letter-spacing: unset;
        text-transform: unset;
      }
    `}
`

export const STitle = styled(Caption)`
  color: var(--c-black);
  text-transform: uppercase;
`

export const SDescription = styled(Text)`
  max-width: ${pxToRem(600)}rem;
`

export const SActionLabel = styled.div`
  margin-right: 0.5rem;
`
